import React from 'react';
import {Dialog,DialogTitle,DialogContent,DialogActions,Typography,IconButton,Button,Grid,TextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik } from 'formik';
import swal from 'sweetalert';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { fetchData,postData } from "../redux/apiSlice";
import InputMask from 'react-input-mask';
const SendSMS = ({openSMSDialog,setOpenSMSDialog,selectedPhoneNumbers,handleFreezStart,handleFreezStop,numberFlag,event_from}) => {
    const dispatch = useDispatch();

    const smsSchema =(numberFlag)=> Yup.object().shape({
        message: Yup.string().required('Message is required'),
        phone_number: numberFlag == 1 ? Yup.string()
                            .min(14, 'Phone number must be of 10 digit!')
                            .max(14, 'Phone number must be of maximum 10 digit!')
                            .required('Phone number is required'):''
    });
    
    return (
        <Dialog
            open={openSMSDialog}
            onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                setOpenSMSDialog(false);
            }
            }}
            fullWidth
            maxWidth="sm"
            PaperProps={{
            sx: {
            borderRadius: '12px',
            padding: '20px',
            },
            }}
        >
            <Formik
                initialValues={{ message: '', phone_number: '' }}
                validationSchema={smsSchema(numberFlag)}
                onSubmit={async (values, { resetForm }) => {
                handleFreezStart();
                const apiUrl = '/sendSMSAffiliates';
                const args = {
                    message: values.message,
                    phoneNo: numberFlag ==1 ? [values.phone_number] : selectedPhoneNumbers,
                    from:event_from
                }
                const res = await dispatch(postData({ apiUrl, args })).unwrap();
                if (res.success === true) {
                    swal({
                    title: "Success",
                    text: res.data,
                    icon: "success",
                    button: "Ok",
                    })
                    setOpenSMSDialog(false);
                    handleFreezStop();
                }
                else{
                swal({
                    title: "Failure",
                    text: res.message,
                    icon: "error",
                    button: "Ok",
                })
                handleFreezStop();
                }
                resetForm();
                }}
            >
                {({values,errors,touched,handleChange,handleSubmit,handleBlur,setFieldValue,setFieldTouched}) => (
                    <form onSubmit={handleSubmit}>
                        <DialogTitle className="dialog-title">
                            <Typography variant="h6" fontWeight="bold">
                                Send SMS
                            </Typography>
                            <IconButton onClick={() => setOpenSMSDialog(false)}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
        
                        <DialogContent>
                            {numberFlag === 1 && (
                                <InputMask
                                    mask="(999) 999-9999"
                                    maskChar={null}
                                    value={values.phone_number}
                                    onChange={(e) => setFieldValue('phone_number', e.target.value)}
                                    onBlur={() => setFieldTouched('phone_number', true)}
                                >
                                    {(inputProps) => (
                                    <TextField
                                        {...inputProps}
                                        fullWidth
                                        required
                                        margin="dense"
                                        placeholder="Phone Number"
                                        label="Phone Number"
                                        variant="outlined"
                                        name="phone_number"
                                        className="blue-border"
                                        error={touched.phone_number && Boolean(errors.phone_number)}
                                        helperText={touched.phone_number && errors.phone_number}
                                    />
                                    )}
                                </InputMask>
                            )}
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Message"
                                type="text"
                                fullWidth
                                multiline
                                rows={4}
                                name="message"
                                value={values.message}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.message && Boolean(errors.message)}
                                helperText={touched.message && errors.message}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'center', width: '100%' }}>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button
                                        variant="contained"
                                        sx={{ minWidth: 150 }}
                                        onClick={() => setOpenSMSDialog(false)}
                                    >
                                        CLOSE
                                    </Button>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button
                                        variant="contained"
                                        sx={{ minWidth: 150 }}
                                        color="success"
                                        type="submit"
                                    >
                                        Send Message
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
  };
  
  export default SendSMS;